import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Container} from "../Home/styleHome";
import img_disputa from "../imagens/disputa@2x.png";
import {ImagemDisputa} from "../Disputa/styleDisputa";
import banner from "../imagens/banner.png";

export const Modal = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  justify-items: center;
  position: fixed;
  overflow: hidden;
  z-index: 99999;
  background: black;
  opacity: 0.5;
  height: 100vh;
  width: 100vw;
`;

export const Modal2 = styled.div`
  display: flex;
  position: fixed;
  overflow: hidden;
  z-index: 99999;
  height: 100vh;
  width: 100vw;
  padding:0;
  margin:0;
`;

export const ContainerModal = styled.div`
  position: absolute;
  overflow: hidden;
  z-index: 999999;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;

  padding:0;
  background: white;
  border-radius: 10px;
  height: 500px;
  width: 700px;
  
`;

export const Badge = styled.div`
  display: flex;
  position: absolute;
  right: 0;
  z-index: 999999;
  height: 30px;
  width: 30px;
  background: #b4382b;
  justify-items: center;
  align-items: center;
  text-align: center;
  justify-content: center;
  
  
  div{
  width: 100%;
  display: flex;
  justify-items: center;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: white;
  cursor: pointer;
    :hover{
         transform: scale(1.3);
         font-weight: bold;
  }
  }
  
  :hover{
         background: #ff1205;
  }


`;

export const ModalAviso = ({toogleBanner}) => {
    return (
        <>
            <Modal/>
            <Modal2>
                <ContainerModal>
                    <Badge><div onClick={() => toogleBanner()}>x</div></Badge>
                    <div>
                        <img
                        src={banner}
                        height={"auto"}
                        width={"99%"}
                        alt={"banner"}
                    /></div>
                </ContainerModal>
            </Modal2>
        </>
    )
}
